<template>
  <div class="pay-container">
    <div class="header">
      <div class="back" @click="closePay">‹</div>
      <div class="head-title">恢复影像</div>
<!--      <div class="close" @click="closePay">×</div>-->
    </div>
    <div class="pay-item">
      <span class="hospital">{{ payItem.hospital_name }}</span>
      <span class="common-item">
        <span class="item-prop">患者姓名：</span>
        <span class="item-value">{{ payItem.hospital_patient_name }}</span>
      </span>
      <span class="common-item">
        <span class="item-prop">检查类型：</span>
        <span class="item-value">{{ payItem.Modality }}</span>
      </span>
      <span class="common-item">
        <span class="item-prop">检查部位：</span>
        <span class="item-value">{{ payItem.hospital_check_place }}</span>
      </span>
      <span class="common-item">
        <span class="item-prop">检查时间：</span>
        <span class="item-value">{{ payItem.hospital_check_time }}</span>
      </span>
    </div>
    <div class="pay-item">
      <div class="tip">影像恢复成功后，可保存八年时间。</div>
    </div>
    <div class="footer">
      <div class="pay-money">支付金额：<label class="red">￥0.01元</label></div>
      <div class="pay-btn" @click="toPay">去支付</div>
    </div>
    <popup :show.sync="failedPayShow">
      <div class="noelectron-box">
        <div class="close" @click="failedPayShow=false">X</div>
        <div class="text">下单失败<br>请稍后重试</div>
      </div>
    </popup>
  </div>
</template>
<script>
import { toOrder } from "@/api/api";
import popup from "@/views/Report/pupup.vue";
export default {
  components: {popup},
  props: {
    payItem: {},
    openId: ''
  },
  data () {
    return {
      loading: false,
      showPay: false,
      failedPayShow: false
    }
  },
  methods: {
    getDevice() {
      return new Promise((resolve, reject) => {
        const ua = navigator.userAgent.toLowerCase();
        if(ua.match(/MicroMessenger/i)=="micromessenger") {
          //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
          wx.miniProgram.getEnv((res)=>{
            if (res.miniprogram) {
              console.log("在小程序里");
              resolve({wx: true, mp: true});
            } else {
              console.log("不在小程序里");
              resolve({wx: true, mp: false});
            }
          })
        }else{
          console.log('不在微信里');
          resolve({wx: false, mp: false});
        }
      });

    },
    closePay() {
      this.$emit('close')
    },
    toPay() {
      console.log('this.openId', this.openId)
      this.$emit('payloading', true)
      this.getDevice().then((dv) => {
        const payment_method = !dv.mp ? 'W01' : 'W06'
        const open_id = !dv.mp ? '' : this.openId
        toOrder(this.payItem.id, payment_method, open_id)
          .then((res) => {
            console.log('下单成功', res)
            if (res.code==1) {
              console.log('re.data.payinfo', res.data.payinfo)
              if (!dv.mp) {
                window.localStorage.setItem('cururl', window.location.href)
                window.localStorage.getItem('cururl')
                window.location = res.data.payinfo
              } else {
                const payinfo = JSON.parse(res.data.payinfo)
                console.log('payinfo', payinfo)
                uni.postMessage({
                  data: {
                    payinfo,
                    url: window.location.href.split('#')[0]
                  }
                });
                uni.navigateBack()
              }
            }
          })
          .catch(() => {
            console.log('下单失败')
            this.failedPayShow = true
          })
          .finally(() => {
            this.$emit('payloading', false)
          })
      })
    }
  }
}
</script>
<style scoped lang="less">
.pay-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.95);
  .footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 60px;
    background-color: #fefefe;
    border-top: 1px #d5d5d5 solid;
    color: #f5f5f5;
    .pay-money {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      color: #333333;
    }
    .pay-btn {
      width: 120px;
      background-color: red;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      font-size: 20px;
      font-weight: bold;
    }
    .red {
      color: red !important;
    }
  }

  .header {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 60px;
    position: relative;
    background-color: #2f3680;
    color: #f5f5f5;
    .back {
      position: absolute;
      left: 0;
      width: 60px;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 40px;
    }
    .close {
      position: absolute;
      right: 0;
      width: 60px;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 35px;
    }
  }
  .pay-item {
    display: flex;
    flex-direction: column;
    padding: 15px 30px;
    .common-item {
      font-size: 18px;
      margin-top: 5px;
    }
    .tip {
      font-size: 18px;
    }
  }
}
</style>

